<template>
  <div class="wrapper">

    <div class="main-panel">
      <top-navbar v-if="showNavbar"></top-navbar>

      <dashboard-content>

      </dashboard-content>

    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    data() {
      return {showNavbar: true,}
    },
    methods: {

    },
    mounted() {
      this.showNavbar = !this.$route.query['embedded']
    }
  }

</script>
